import { render, staticRenderFns } from "./Spiritual.vue?vue&type=template&id=b7a759bc&"
import script from "./Spiritual.vue?vue&type=script&lang=js&"
export * from "./Spiritual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports